export default "__VITE_ASSET__B_rfXmB0__"